import { useTranslation } from "react-i18next";

import { Text } from "components";

import DashboardTodoContent from "../shared/DashboardTodoContent";

import classes from "./TodoSection.module.css";

const TodoSection = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <Text className={classes.title}>{t("dashboard.todo.title")}</Text>

      <div className={classes.list}>
        <DashboardTodoContent contentInsetX="16px" />
      </div>
    </div>
  );
};

export default TodoSection;
